export default "__VITE_ASSET__DxIX$YrR__"